export default {"src":"/_next/static/media/0xc2125882318d04d266720b598d620f28222f3abd.3bd8ca5a.svg","height":26,"width":26,"blurWidth":0,"blurHeight":0};